/* @flow */

import React from "react";

import { FormattedMessage } from "react-intl";
import Icon from "../../../general/Icon";
type sizeType = "lg" | "2x" | "3x" | "4x";

/**
 * Renders an icon with a label.
 */
const IconWithLabel = ({ size, symbol, labelId }: { size: sizeType; symbol: string; labelId: string }) => {
    return (
        <React.Fragment>
            <Icon size={size} symbol={symbol} />
            &nbsp;
            <FormattedMessage id={labelId}>
                {(txt: any) => <span className="vertical-align">{txt}</span>}
            </FormattedMessage>
        </React.Fragment>
    );
};

export default IconWithLabel;
